import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from 'src/app/globals';
import { Approved } from '../modal/approved';

@Injectable({
    providedIn: 'root'
})

export class ApprovedService {
    constructor(private httpclient: HttpClient, private global: Globals) {
        console.log(this.global.loggedUser.token);
    }

    GetApprovedList() {

        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + '/approvedEmail/getAllByUserId/' + this.global.loggedUser.user.user_reg_id, { headers:header });

    }
    GetAllApprovedList() {
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + '/approvedEmail/getAllApprovedByUserId/' + this.global.loggedUser.user.user_reg_id, { headers:header });

    }
 AddApproved_HealthCard(approved: Approved) {
    
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + "/approvedEmail", {
            "senderID": approved.senderId,
            "ccId": "",
            "toId": "",
            "body": approved.body,
            "date_time": approved.dateTime,
            "amount": approved.amount,
            "hide": approved.hide,
            "star": approved.star,
            "deleted": false,
            "extra1": "",
            "extra2": "",
            "email_Id": this.global.loggedUser.user.user_reg_id,
            "emailData": null,
            "user_id": this.global.loggedUser.user.user_reg_id,
            "attachment": approved.attachment,
            "sub": approved.sub,
            "spec": approved.spec,
            "remark": approved.remark
        }, { headers:header });
    }

    starUnstar(appEmailId: any, star: any) {
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        var urlString = this.global.G_apiUrl + '/approvedEmail/starUnstar/' + `${appEmailId}` + '/' + `${star}`;
        return this.httpclient.put(urlString, {}, { responseType: 'text', headers: header });
    }

    hideUnhide(appEmailId: any, hide: any) {
        debugger;
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        var urlString = this.global.G_apiUrl + '/approvedEmail/hideUnhide/' + appEmailId + '/' + hide;
        return this.httpclient.put(urlString, {}, { responseType: 'text', headers: header });
    }

    Delete_HealthCard(id: any) {
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.delete(this.global.G_apiUrl + '/approvedEmail/' + id, { headers:header, responseType: 'text' });
    }

  deleteMultiple(approved:any) {
        debugger;
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + "/approvedEmail/multipleDelete",approved,{ headers:header, responseType: 'text'});
    }
   starMultiple(approved:any) {
        debugger;
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + "/approvedEmail/multipleStarUnstar",approved,{ headers:header, responseType: 'text'});
    }

    hideMultiple(approved:any) {
        debugger;
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + "/approvedEmail/multipleHidden",approved,{ headers:header, responseType: 'text'});
    }

    forwordMultiple(approved) {
        debugger;
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + "/approvedEmail/multipleForword/"+ this.global.loggedUser.user.user_reg_id,approved,{ headers:header, responseType: 'text'});
    }

    GetSendList() {
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + '/approvedEmail/getAllByUserId/' + this.global.loggedUser.user.user_reg_id, { headers:header });

    }
    Delete_Trash(id: any) {
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.delete(this.global.G_apiUrl + '/approvedEmail/deleteTrash/' + id, { headers:header, responseType: 'text' });
    }

 Delete_TrashMultiple(trashObj: any) {
        let header:HttpHeaders=new HttpHeaders();
        header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post(this.global.G_apiUrl + '/approvedEmail/deleteTrashMultiple',trashObj ,{ headers:header, responseType: 'text' });
    }
    
 GetSenderName() {
    let header:HttpHeaders=new HttpHeaders();
    header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.get(this.global.G_apiUrl + '/approvedEmail/getSenderName/'+ this.global.loggedUser.user.user_reg_id ,{ headers:header});
}


    
//   deleteMultiple(approved:any) {
//         debugger;
//         let header:HttpHeaders=new HttpHeaders();
//         header=header.append('Authorization', "Bearer " + this.global.loggedUser.token);
//         return this.httpclient.post(this.global.G_apiUrl + "/approvedEmail/multipleDelete",approved,{ headers:header, responseType: 'text'});
//     }
}